import CreatorLink from "./CreatorLink";
import React from "react";
import { creatorsFromSource } from "../helpers.mjs";

const Creators = ({source}) => {
    const creators = creatorsFromSource(source);

    return <>
        {creators.map((c,index) => {
            return <>
                <CreatorLink key={`creatorlink${index}`} creator={c.creator} type={c.type} typeD={c.typeD} />
                {(index === (creators.length-2) && <span>&nbsp;and&nbsp;</span>) || (index !== (creators.length-1) && creators.length>1 && <span>,&nbsp;</span>)}
            </>
        })}
    </>
}

export default Creators;